export default {
  API_URL: 'https://cbi-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://cbisandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
